import {toastProps} from "../../screens/BaseProps";
import {Severity} from "enums/severity";
import useToast from "hooks/toasts/useToast";

function useSuccessToast(props: toastProps, message: string) {
  return useToast(props, Severity.Success, message)
}

export default useSuccessToast
